module.exports = __webpack_public_path__ + "static/img/introduce_13.53e308e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_13.png
// module id = tOdd
// module chunks = 1